module.exports = __webpack_public_path__ + "static/image-bacterium-80ae5d84f62e9cd6a04465e73494a1cd.png";